"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _DeskingQuestionsModel = _interopRequireDefault(require("./DeskingQuestionsModel"));

var _DilawriCBBModelGenerator = _interopRequireDefault(require("./DilawriCBBModelGenerator"));

var _default = {
  DeskingQuestionsModel: _DeskingQuestionsModel.default,
  DilawriCBBModelGenerator: _DilawriCBBModelGenerator.default
};
exports.default = _default;